/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import {
  APPLICATION_STATUS_BASE,
  APPLICATION_STATUS_CONCERN_SUMMARY,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_DONE,
  APPLICATION_STATUS_POWER_OF_ATTORNEY,
  APPLICATION_STATUS_REFINEMENT,
  APPLICATION_STATUS_SUMMARY,
} from "@/src/services/generalCivilLaw/applicationStatus";
import React from "react";
import ProgressBar from "@/src/components/ProgressBar/ProgressBar";
import progressBarsteps from "./progressBarSteps";
import generalCivilLawFormSteps from "@/src/services/generalCivilLaw/formSteps";
import HintBox from "@/src/components/Box/HintBox/HintBox";
import { FormSteps } from "@/src/types/FormServiceBase";
import Base from "@/src/components/Form/CivilLaw/Base";
import Refinement from "@/src/components/Form/Common/AiAssessment/Refinement";
import ConcernSummary from "@/src/components/Form/Common/AiAssessment/ConcernSummary";
import { DocumentsForm } from "@/src/components/Form/DocumentsForm/DocumentsForm";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_BASE]: {
    ...generalCivilLawFormSteps[APPLICATION_STATUS_BASE],
    render: (props) => (
      <>
        <HintBox headline={"Wir kümmern uns um Ihr Anliegen!"}>
          <p>
            Bitte schildern Sie uns anhand der folgenden Fragen kurz Ihre Situation. Jede Information hilft uns dabei, Sie bestmöglich zu beraten und direkt
            rechtliche Schritte einleiten zu können. Sollten Sie bei Fragen unsicher sein, machen Sie sich hierüber keine Sorgen: Sie können zusätzlich den Fall
            noch frei aus Ihrer Sicht schildern.
          </p>
        </HintBox>
        <ProgressBar steps={progressBarsteps} active={"concern"} progress={25} />
        <Base {...props} hideCaseCategories={true} />
      </>
    ),
  },
  [APPLICATION_STATUS_REFINEMENT]: {
    ...generalCivilLawFormSteps[APPLICATION_STATUS_REFINEMENT],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"concern"} progress={25} />
        <Refinement {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_CONCERN_SUMMARY]: {
    ...generalCivilLawFormSteps[APPLICATION_STATUS_CONCERN_SUMMARY],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"concern"} progress={25} />
        <ConcernSummary {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DOCUMENTS]: {
    ...generalCivilLawFormSteps[APPLICATION_STATUS_DOCUMENTS],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"documents"} progress={75} />
        <DocumentsForm submitProps={props.submitProps} product={props.product} />
      </>
    ),
  },
  [APPLICATION_STATUS_SUMMARY]: generalCivilLawFormSteps[APPLICATION_STATUS_SUMMARY],
  [APPLICATION_STATUS_POWER_OF_ATTORNEY]: generalCivilLawFormSteps[APPLICATION_STATUS_POWER_OF_ATTORNEY],
  [APPLICATION_STATUS_DONE]: generalCivilLawFormSteps[APPLICATION_STATUS_DONE],
};

export default formSteps;
